import React from 'react'
import { globalState } from '@codeleap/store'
import { SuccessOverlay } from '../../SuccessOverlay'
import { CommunityFeed } from '@/types'

const reportedPosts = globalState<{ [id: CommunityFeed['id']]: boolean }>({})

export const ReportOverlay = ({ id }: { id: CommunityFeed['id'] }) => {
  const showOverlay = ReportOverlay.useIsReported(id)

  return (
    <SuccessOverlay
      visible={showOverlay}
      icon='empty-check'
      title={`Thanks for reporting!`}
      description={
        <>
          For your safety and experience, we will no
          <br />
          longer show this content or others with the
          <br />
          same connotation
        </>
      }
    />
  )
}

ReportOverlay.report = (id: CommunityFeed['id']) => {
  reportedPosts.set({
    [id]: true,
  })
}
ReportOverlay.useIsReported = (id: CommunityFeed['id']) => reportedPosts.use(s => s?.[id] ?? false)
